import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { BaseRules, TextValues } from './maine.model';
import { PipBaseStateComponent } from '../pip-base-state.component';
import {
  CoverageLimit,
  PersonalInjuryProtectionSelection,
} from '../../../config/pip-constants';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-maine',
  templateUrl: './maine.component.html',
  styleUrls: ['./maine.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    JsonPipe,
    TruncateModule,
    TooltipModule,
  ],
})
export class MaineComponent extends PipBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('maine', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('maine', null);
    }
  }
  override dynamicRuleQueryBuilder(): string {
    // Combine all conditions for 'ShowRejectAndSelect'
   if (
     this.baseRulesService.personalInjuryProtectionSelection ===
     PersonalInjuryProtectionSelection.IndividualStateCoverage
   ) {
     return 'ShowRejectAndSelect';
   }
     if (
       this.baseRulesService.personalInjuryProtectionSelection ===
         PersonalInjuryProtectionSelection.AcceptCoverage &&
       this.baseRulesService.coverageLimit ===
         CoverageLimit.MaximumLimitsAvailable
     ) {
       return 'ShowRejectAndSelect5KFixed';
     }
     if (
       this.baseRulesService.personalInjuryProtectionSelection ===
         PersonalInjuryProtectionSelection.AcceptCoverage &&
       this.baseRulesService.coverageLimit === CoverageLimit.VaryByState
     ) {
       return 'ShowRejectAndSelectFixed';
     }
     if (
       this.baseRulesService.personalInjuryProtectionSelection ===
         PersonalInjuryProtectionSelection.RejectWherePermissible ||
       (this.baseRulesService.personalInjuryProtectionSelection ===
         PersonalInjuryProtectionSelection.AcceptCoverage &&
         this.baseRulesService.coverageLimit ===
           CoverageLimit.MinimumLimitsRequired)
     ) {
       return 'ShowRejectAndSelect2KFixed';
     }
  }
}
